import { EvmNFTCollection } from '@repo/types-client';

import { externalBaseContractAddresses } from './base-external-contract-addresses';

export interface BaseExternalNFTCollections {
  readonly doodlesCertifiedViral: EvmNFTCollection;
  readonly doodlesComics: EvmNFTCollection;
}

export const baseExternalNFTCollections: BaseExternalNFTCollections = {
  doodlesCertifiedViral: {
    contractName: 'DoodlesCertifiedViral',
    getAddress: () => externalBaseContractAddresses.doodlesCertifiedViral,
    getMetadataURI: (tokenId: string) => {
      switch (tokenId) {
        case '0':
          return 'ipfs://bafkreia46ils4vdp5ofbnuearsno3px6zhtt2jke4rmkqhlcgzeosrmchu';
        case '1':
          return 'ipfs://bafkreieife7nsk7mse74k4e26xns6wkb3ugbambt6lsnpxqbv7porwc5oy';
        case '2':
          return 'ipfs://bafkreiey3zqm2z7f24ppxxqhcwwqlegdmbnpc7tlohz7iu23wlt7xja54m';
        case '3':
          return 'ipfs://bafkreidczmcuopuawviljqabocqpas6vmo53exsmroygywasvyll2b3m4y';
        case '4':
          return 'ipfs://bafkreiabvnbuhbuotsie2qkm5kdyw3qdjhuzcp7pn43o4ctuswa4bcwzam';
        case '5':
          return 'ipfs://bafybeiaczusbaujrles5znzlauxtvsbfoxpic3ovun2l27ipco46vpav3u';
        case '6':
          return 'ipfs://bafybeifubiwmm6hqxkz652lr6dmkqdib4gyb5kb7iltubmgsh2zrw3t5wq';
        case '7':
          return 'ipfs://bafybeic4vrzgw7fog7byvl23vuh2o7obe6tip4mdpn4itavw7lwfuclev4';
        case '8':
          return 'ipfs://bafybeibddbymk64p2apl3s45zbxlxvbxekicd2e2ftgrdn6q2kvlkvwzpq';
        default:
          return '';
      }
    },
    tokenType: 'ERC1155',
    chain: 'base',
  },
  doodlesComics: {
    contractName: 'DoodlesComics',
    getAddress: () => externalBaseContractAddresses.doodlesComics,
    getMetadataURI: (tokenId: string) => {
      switch (tokenId) {
        case '0':
          return 'ipfs://bafybeiefryrfyhanfsiyme4427fgh3fza3maeawvjigmu3aybfmtfyncba';
        case '1':
          return 'ipfs://bafybeibbz22err3nmbekmc2msxvigxlsuhqs4nbpwg4oyj4xmqfj7rvlee';
        case '2':
          return 'ipfs://bafybeiamjqgdgxifhusvk5y5os4oqststh6n76koui5k4cwiva6fapop6u';
        case '3':
          return 'ipfs://bafybeibbwduib6pwdcdqdgohz4go3spgiwwxuekyuxtahlwhxjhzuh4hra';
        default:
          return '';
      }
    },
    tokenType: 'ERC1155',
    chain: 'base',
  },
} as const;
